var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "box" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "configuration-reference" }, [
        _c("div", { staticClass: "card-row row" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "md-field",
                { staticClass: "create-community" },
                [
                  _c("label", { staticClass: "card-header" }, [
                    _vm._v("Add Owner Name")
                  ]),
                  _vm._v(" "),
                  _c("md-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: { name: "ownerName", placeholder: "Add Owner Name" },
                    on: {
                      input: function($event) {
                        _vm.ownerName = _vm.sanitizeInput($event)
                      }
                    },
                    model: {
                      value: _vm.ownerName,
                      callback: function($$v) {
                        _vm.ownerName =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "ownerName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("ownerName"),
                      expression: "errors.has('ownerName')"
                    }
                  ],
                  staticClass: "error"
                },
                [_vm._v(_vm._s(_vm.errors.first("ownerName")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "md-field",
                { staticClass: "create-community" },
                [
                  _c("label", { staticClass: "card-header" }, [
                    _vm._v("Add Owner Email")
                  ]),
                  _vm._v(" "),
                  _c("md-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|email",
                        expression: "'required|email'"
                      }
                    ],
                    attrs: {
                      name: "ownerEmail",
                      id: "ownerEmail",
                      placeholder: "Add Owner Email"
                    },
                    on: {
                      input: function($event) {
                        _vm.ownerEmail = _vm.sanitizeInput($event)
                      }
                    },
                    model: {
                      value: _vm.ownerEmail,
                      callback: function($$v) {
                        _vm.ownerEmail =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "ownerEmail"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("ownerEmail"),
                      expression: "errors.has('ownerEmail')"
                    }
                  ],
                  staticClass: "error"
                },
                [_vm._v(_vm._s(_vm.errors.first("ownerEmail")))]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "submitBtn" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-raised md-round md-accent",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.saveOwner()
                    }
                  }
                },
                [_vm._v("Save")]
              ),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  staticClass: "md-raised md-round md-accent",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.cancel()
                    }
                  }
                },
                [_vm._v("Cancel")]
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("h2", { staticClass: "match-header" }, [_vm._v("Add Protopia Owner")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b6922278", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6922278","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfigurationProtopiaOwnerAdd.vue
// module id = null
// module chunks = 